import ApiRequest from '../api/request';

type Params = {
  route?: 'data';
  action: 'create' | 'delete' | 'update' | 'query';
  id?: string;
  model: string;
  params: any;
};

export default class Data {
  static async Interact(params: Params, apiToken: string) {
    try {
      if (params.action === 'create') {
        return Data.Create(params, apiToken);
      }
      if (params.action === 'delete') {
        return Data.Delete(params, apiToken);
      }
      if (params.action === 'query') {
        return Data.Query(params, apiToken);
      }
      if (params.action === 'update') {
        return Data.Update(params, apiToken);
      }
    } catch (err: any) {
      return { error: err.message };
    }
  }

  static async Create(params: Params, apiToken: string) {
    try {
      // Convert to form data
      const formData = new FormData();
      const paramKeys = Object.keys(params.params);
      for (let i = 0; i < paramKeys.length; i++) {
        // TODO: Make this somehow check the schema fields and make sure it knows what types are files
        if (paramKeys[i] !== 'files') {
          formData.set(paramKeys[i], params.params[paramKeys[i]]);
        } else {
          const fileKeys = Object.keys(params.params[paramKeys[i]]);
          if (fileKeys.length > 0) {
            for (let j = 0; j < fileKeys.length; j++) {
              formData.append(paramKeys[i], params.params[paramKeys[i]][fileKeys[j]]);
            }
          }
        }
      }
      formData.set('model', params.model);

      const response = await ApiRequest.sendRequest({
        method: 'post',
        params: formData,
        path: `data/${params.action}`,
        token: apiToken,
        contentType: 'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
      });
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }

  static async Delete(params: Params, apiToken: string) {
    try {
      const deleteParams = {
        model: params.model,
        id: params.id,
      };
      const response = await ApiRequest.sendRequest({
        method: 'post',
        params: deleteParams,
        path: `data/${params.action}`,
        token: apiToken,
      });
      // console.log(response.data);
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }

  /**
    Query model document
    @note Parameters come in an object named params
    @param {JSON}  params.params  is the parameters to create with
    @param {String}  params.model is the model type being created
    @returns  {JSON}  result of new object and error is null or contains error if there
  */
  static async Query(params: Params, apiToken: string) {
    try {
      const queryParams = {
        model: params.model,
        params: params.params,
      };
      const response = await ApiRequest.sendRequest({
        method: 'post',
        params: queryParams,
        path: `data/${params.action}`,
        token: apiToken,
      });
      // console.log(response.data);
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }

  static async Update(params: Params, apiToken: string) {
    try {
      // Convert to form data
      const formData = new FormData();
      const paramKeys = Object.keys(params.params);
      for (let i = 0; i < paramKeys.length; i++) {
        // TODO: Make this somehow check the schema fields and make sure it knows what types are files
        if (paramKeys[i] !== 'files') {
          formData.set(paramKeys[i], params.params[paramKeys[i]]);
        } else {
          const fileKeys = Object.keys(params.params[paramKeys[i]]);
          if (fileKeys.length > 0) {
            for (let j = 0; j < fileKeys.length; j++) {
              formData.append(paramKeys[i], params.params[paramKeys[i]][fileKeys[j]]);
            }
          }
        }
      }
      formData.set('model', params.model);
      formData.set('id', params.id as string);

      const response = await ApiRequest.sendRequest({
        method: 'post',
        params: formData,
        path: `data/${params.action}`,
        token: apiToken,
        contentType: 'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
      });
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }
}
